import { styled } from '@mui/material';

import { Button } from 'components';

export const ContentW = styled('div')`
  width: 100%;
  max-width: 1106px;
  @media (max-width: 1023px) {
    width: 95%;
    margin: 0 auto;
    padding: 0px;
  }
  @media (min-width: 1920px) {
    margin: 0 auto;
  }
`;

export const TopMenuW = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: top;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const StyledBtn = styled(Button)`
  all: unset;
  position: relative;
  display: flex;
  align-items: center;
  height: 34px;
  width: unset;
  padding-left: 0;
  min-width: unset;
  border-radius: 50%;
  background-color: transparent;

  &:hover {
    all: unset;
    position: relative;
    display: flex;
    align-items: center;
    height: 34px;
    width: unset;
    padding-left: 0;
    min-width: unset;
    border-radius: 50%;
    background-color: rgba(0, 0, 0, 0.04);
  }
`;

export const PageTitle = styled('h2')`
  font-size: 20px;
  color: #999;
  margin: 0;
  white-space: nowrap;
`;
